import { isNumber } from './index';

/**
 * Parse CMS /users URL search string into API query suffix and UI defaults.
 */
export function parseUsersListFilters(searchString) {
    const urlParams = new URLSearchParams(searchString || '');

    const filter_first_name = urlParams.get('first_name');
    const filter_last_name = urlParams.get('last_name');
    const filter_email = urlParams.get('email');
    const filter_gender = urlParams.get('gender');
    const filter_birth_country = urlParams.get('country');
    const filter_birth_city = urlParams.get('city');
    const filter_living_country = urlParams.get('living_country');
    const filter_living_city = urlParams.get('living_city');
    const filter_talent = urlParams.get('talent');
    const filter_course = urlParams.get('course');
    const filter_size = urlParams.get('size') ? urlParams.get('size') : 10;
    const filter_is_verified = urlParams.get('is_verified') ? urlParams.get('is_verified') : -1;

    let filter_from_year = isNumber(urlParams.get('from_year')) ? urlParams.get('from_year') : null;
    let filter_from_month = urlParams.get('from_month');
    let filter_from_day = urlParams.get('from_day');
    let filter_fbirthdate = '';

    if (filter_from_year) {
        filter_from_month = isNumber(filter_from_month) ? filter_from_month : 1;
        filter_from_day = isNumber(filter_from_day) ? filter_from_day : 1;
        filter_fbirthdate = `${filter_from_year}-${filter_from_month}-${filter_from_day}`;
    }

    let filter_to_year = isNumber(urlParams.get('to_year')) ? urlParams.get('to_year') : null;
    let filter_to_month = urlParams.get('to_month');
    let filter_to_day = urlParams.get('to_day');
    let filter_tbirthdate = '';
    if (filter_to_year) {
        filter_to_month = isNumber(filter_to_month) ? filter_to_month : 1;
        filter_to_day = isNumber(filter_to_day) ? filter_to_day : 1;
        filter_tbirthdate = `${filter_to_year}-${filter_to_month}-${filter_to_day}`;
    }

    let filter_query = '';
    let hasActiveFilters = false;

    if (filter_is_verified && filter_is_verified !== '-1') {
        filter_query += `&is_verified=${filter_is_verified}`;
    }

    if (filter_first_name && filter_first_name.length > 0) {
        filter_query += `&first_name=${filter_first_name}`;
        hasActiveFilters = true;
    }

    if (filter_last_name && filter_last_name.length > 0) {
        filter_query += `&last_name=${filter_last_name}`;
        hasActiveFilters = true;
    }

    if (filter_email && filter_email.length > 0) {
        filter_query += `&email=${encodeURIComponent(filter_email)}`;
        hasActiveFilters = true;
    }

    if (filter_gender && filter_gender.length > 0) {
        filter_query += `&gender=${filter_gender}`;
        hasActiveFilters = true;
    }

    if (filter_birth_country && filter_birth_country.length > 0) {
        filter_query += `&country=${filter_birth_country}`;
        hasActiveFilters = true;
    }

    if (filter_birth_city && filter_birth_city.length > 0) {
        filter_query += `&city=${filter_birth_city}`;
        hasActiveFilters = true;
    }

    if (filter_living_country && filter_living_country.length > 0) {
        filter_query += `&livingcountry=${filter_living_country}`;
        hasActiveFilters = true;
    }

    if (filter_living_city && filter_living_city.length > 0) {
        filter_query += `&livingcity=${filter_living_city}`;
        hasActiveFilters = true;
    }

    if (filter_fbirthdate && filter_fbirthdate.length > 0) {
        filter_query += `&fbirthdate=${filter_fbirthdate}`;
        hasActiveFilters = true;
    }
    if (filter_tbirthdate && filter_tbirthdate.length > 0) {
        filter_query += `&tbirthdate=${filter_tbirthdate}`;
        hasActiveFilters = true;
    }

    if (filter_talent && isNumber(filter_talent)) {
        filter_query += `&talent=${filter_talent}`;
        hasActiveFilters = true;
    }

    if (filter_course && isNumber(filter_course)) {
        filter_query += `&course=${filter_course}`;
        hasActiveFilters = true;
    }

    if (filter_size && isNumber(filter_size)) {
        filter_query += `&size=${filter_size}`;
    }

    return {
        filterQuery: filter_query,
        hasActiveFilters,
        filter_first_name,
        filter_last_name,
        filter_email,
        filter_gender,
        filter_birth_country,
        filter_birth_city,
        filter_living_country,
        filter_living_city,
        filter_talent,
        filter_course,
        filter_size,
        filter_is_verified,
        filter_from_year,
        filter_from_month,
        filter_to_year,
        filter_to_month,
    };
}
